module.exports = "https://static.futunn.com/components/common-offline-activity-session/images/bg-full.f1c31a3eb9.png";